import { FC } from "react";
import { Loading, ShowActionsProps, TopToolbar } from "react-admin";
import { Delivery } from "../../types";
import AssignDriverDialog from "./actions/AssignDriverDialog";
import CannotPickDialog from "./actions/CannotPickDialog";
import EndDeliveryDialog from "./actions/EndDeliveryDialog";
import StartDeliveryDialog from "./actions/StartDeliveryDialog";
import VerifyDeliveryDialog from "./actions/VerifyDeliveryDialog";
import { deliveryStatus } from "./util";

const DeliveryActions: FC<ShowActionsProps> = (props) => {
  const { data } = props;
  const model = data as Delivery;
  // const history = useHistory();

  if (!model) {
    return <Loading />;
  }

  // Don't show actions for these final/completed statuses
  if (
    model.status === deliveryStatus.CANCELLED ||
    model.status === deliveryStatus.CANNOT_PICK ||
    (model.status === deliveryStatus.DELIVERED && model.verify_at)
  ) {
    return null; // Return nothing, no actions needed
  }

  // Check if there are any actions to show
  const hasActions =
    model.status === deliveryStatus.NEW ||
    model.status === deliveryStatus.ASSIGNED ||
    model.status === deliveryStatus.PICKED ||
    (model.status === deliveryStatus.DELIVERED && !model.verify_at);

  if (!hasActions) {
    return null; // Return nothing if no actions available
  }

  return (
    <TopToolbar>
      {/* Status: NEW - Only Assign Driver */}
      {model.status === deliveryStatus.NEW && (
        <AssignDriverDialog record={model} />
      )}

      {/* Status: ASSIGNED - Assign Driver, Start Delivery, Cannot Start Delivery */}
      {model.status === deliveryStatus.ASSIGNED && (
        <>
          <AssignDriverDialog record={model} />
          <StartDeliveryDialog record={model} />
          <CannotPickDialog record={model} />
        </>
      )}

      {/* Status: PICKED - Only End Delivery */}
      {model.status === deliveryStatus.PICKED && (
        <EndDeliveryDialog record={model} />
      )}

      {/* Status: DELIVERED - Only Verify Delivery (if not verified yet) */}
      {model.status === deliveryStatus.DELIVERED && !model.verify_at && (
        <VerifyDeliveryDialog record={model} />
      )}
    </TopToolbar>
  );
};

export default DeliveryActions;
